// extracted by mini-css-extract-plugin
module.exports = {"player":"split-loader_player__4ayMm","loader":"split-loader_loader__qvr3b","small":"split-loader_small__NvW4u"};